import { render, staticRenderFns } from "./CProjectUserActionArea.vue?vue&type=template&id=195a51e0&"
import script from "./CProjectUserActionArea.vue?vue&type=script&lang=ts&"
export * from "./CProjectUserActionArea.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports